import { HttpClient } from "../../client/HttpClient";
import {
  VerifyIdentityRequest,
  VerifyIdentityResponse,
} from "../../types/onboarding";

/**
 * Onboarding module — identity verification.
 *
 * All methods use session-token auth (x-access-token header).
 */
export class OnboardingModule {
  constructor(private http: HttpClient) {}

  /**
   * Verify a user's identity.
   *
   * POST /v1/onboarding/verify/
   * Auth: x-access-token: <sessionToken>
   *
   * Sends identity_type_id (from ChannelItem.id) and dynamic fields
   * collected from the user based on the channel's field definitions.
   *
   * Example:
   *   { identity_type_id: 3, fields: { "bank_verification_number": "12345678901" } }
   */
  async verify(params: VerifyIdentityRequest): Promise<VerifyIdentityResponse> {
    return this.http.sessionRequest<VerifyIdentityResponse>(
      "POST",
      "/v1/onboarding/verify/",
      {
        identity_type_id: params.identity_type_id,
        fields: params.fields,
      }
    );
  }
}
